import { Client } from "medpro-sdk";
import AppId from "~/utils/partner";
import { currentEnv } from "~/configs";

export const client = new Client({
  apiRoot: currentEnv.RESTFULL_API_URL,
  appid: AppId,
  partnerid: AppId,
  platform: "pc"
});

// "medpro-sdk": "git+http://gitlab+deploy-token-180303:Z2AoEKy5TShR9811JD49@gitlab.com/medpro/medpro-sdk.git#develop"
